import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type {
	EditorContentFragmentResult,
	EditorContentFragmentValue,
} from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import { ContentOperationsFragment } from '@confluence/entity-operations/entry-points/ContentOperationsFragment.graphql.ts';

import type { useEditorAddCommentPermissionFragment_content$key } from './__generated__/useEditorAddCommentPermissionFragment_content.graphql.ts';

void ContentOperationsFragment;

const editorAddCommentPermissionFragmentNode: GraphQLTaggedNode = graphql`
	fragment useEditorAddCommentPermissionFragment_content on Content @catch {
		...ContentOperationsFragment @relay(mask: false)
	}
`;

/**
 * The operations of the editor document from EditorContentUnifiedQuery, which decide whether the
 * user can add comments. When it is provided, the add comment permission check does not fetch them.
 */
export function useEditorAddCommentPermissionFragment({
	contentId,
}: {
	contentId: string | undefined;
}): EditorContentFragmentResult<
	EditorContentFragmentValue<useEditorAddCommentPermissionFragment_content$key>
> {
	return useEditorContentFragment<useEditorAddCommentPermissionFragment_content$key>(
		'editorAddCommentPermissionFragment',
		editorAddCommentPermissionFragmentNode,
		{ contentId },
	);
}
